import { observable, computed } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import ImageDetailModal from '@src/business-components/images-detail-modal';
import ImageDetailModalStore from '@src/business-components/images-detail-modal/store';
import useModal from '@src/utils/hooks/use-modal';
import locales from './locales';

class FourSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }
  @observable isActive = false;
  // 鼠标移入的索引 hoverIndex
  @observable hoverIndex = 0;
  // 当前点击的索引 currentIndex
  @observable currentIndex = 0;
  // 地图节点被点击
  @observable isMapClick = false;
  // 特写动画加载后去掉3个子图
  @observable detailMpaImgLoadState = false;
  // 地图内容角标
  @observable currentContentIndex = 0;

  list = [
    {
      // name: '大火山口',
      name: locales.mapName.mapName1,
      initialLetter: 'VolcanicCrater',
      id: 1,
      detailImg: require('./images/detail-img1.png'),
      enName: 'VOLCANIC CRATER'
    },
    {
      // name: '海积平原',
      name: locales.mapName.mapName2,
      initialLetter: 'MarinePlain',
      id: 2,
      detailImg: require('./images/detail-img2.png'),
      enName: 'MARINE PLAIN'
    },
    {
      // name: '山丘台地',
      name: locales.mapName.mapName3,
      initialLetter: 'Plateau',
      id: 3,
      detailImg: require('./images/detail-img3.png'),
      enName: 'PLATEAU'
    },
    {
      // name: '堰塞湖区',
      name: locales.mapName.mapName4,
      initialLetter: 'BarrierLake',
      id: 4,
      detailImg: require('./images/detail-img4.png'),
      enName: 'BARRIER LAKE'
    },
    {
      // name: '隆升荒原',
      name: locales.mapName.mapName5,
      initialLetter: 'BarrenUpland',
      id: 5,
      detailImg: require('./images/detail-img5.png'),
      enName: 'BARREN UPLAND'
    }
  ];

  contentList = locales.mapContentList;

  // contentList = {
  //   VolcanicCrater: [
  //     {
  //       name: '火箭残骸',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/VolcanicCrater/detail-content-img-1.png')
  //     },
  //     {
  //       name: '矿井',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/VolcanicCrater/detail-content-img-2.png')
  //     },
  //     {
  //       name: '太阳发电区',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/VolcanicCrater/detail-content-img-3.png')
  //     }
  //   ],
  //   MarinePlain: [
  //     {
  //       name: '火箭残骸',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/MarinePlain/detail-content-img-1.png')
  //     },
  //     {
  //       name: '矿井',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/MarinePlain/detail-content-img-2.png')
  //     },
  //     {
  //       name: '太阳发电区',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/MarinePlain/detail-content-img-3.png')
  //     }
  //   ],
  //   Plateau: [
  //     {
  //       name: '火箭残骸',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/Plateau/detail-content-img-1.png')
  //     },
  //     {
  //       name: '矿井',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/Plateau/detail-content-img-2.png')
  //     },
  //     {
  //       name: '太阳发电区',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/Plateau/detail-content-img-3.png')
  //     }
  //   ],
  //   BarrierLake: [
  //     {
  //       name: '火箭残骸',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/BarrierLake/detail-content-img-1.png')
  //     },
  //     {
  //       name: '矿井',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/BarrierLake/detail-content-img-2.png')
  //     },
  //     {
  //       name: '太阳发电区',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/BarrierLake/detail-content-img-3.png')
  //     }
  //   ],
  //   BarrenUpland: [
  //     {
  //       name: '火箭残骸',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/BarrenUpland/detail-content-img-1.png')
  //     },
  //     {
  //       name: '矿井',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/BarrenUpland/detail-content-img-2.png')
  //     },
  //     {
  //       name: '太阳发电区',
  //       content:
  //         '祖安是一座饱受污染的地下城，位于皮尔特沃夫下方。两座城市曾经不分你我，但是毫无节的工业活动让城中的大小沟壑变成了剧毒的河流。即便如此，多亏了兴旺的黑市、炼金科技和机械增强技术，人们依然能够欣欣向荣地生活。',
  //       img: require('./images/BarrenUpland/detail-content-img-3.png')
  //     }
  //   ]
  // };

  @computed
  get currentContent() {
    const index = this.currentIndex <= 0 ? 0 : this.currentIndex - 1;
    const currentInitialLetter = this.list[index].initialLetter;
    return this.contentList[currentInitialLetter] || [];
  }

  // 图片详情弹窗
  imageDetailModal = new ImageDetailModalStore();

  // 鼠标移入函数
  mouseMove = index => {
    this.hoverIndex = index;
    // console.log(this.hoverIndex);
  };
  // 鼠标移出函数
  mouseOut = () => {
    this.hoverIndex = 0;
  };
  // 点击获取角标
  clickIndex = index => {
    this.hoverIndex = 0;
    this.currentIndex = index;
    this.isMapClick = true;

    this.detailMpaImgLoadTimer = setTimeout(() => {
      this.detailMpaImgLoadState = true;
      clearTimeout(this.detailMpaImgLoadTimer);
    }, 600);
  };

  close = () => {
    this.hoverIndex = 0;
    this.currentIndex = 0;
    this.currentContentIndex = 0;
    this.isMapClick = false;
    this.detailMpaImgLoadState = false;
  };

  tabClick = index => {
    this.currentContentIndex = index;
  };

  openExpandImage = (imageUrl, imageName) => {
    this.imageDetailModal.isOpen = true;
    this.imageDetailModal.imageDetailName = imageName;
    this.imageDetailModal.imageDetailUrl = imageUrl;
    this.imageDetail.open();
  };

  use() {
    const _this = this;
    this.imageDetail = useModal(ImageDetailModal, { store: this.imageDetailModal });
    useMount(async () => {
      // this.clickIndex(1);
      const mapContentTextDom = document.getElementById('mapContentText');
      if (mapContentTextDom) {
        // 鼠标移入事件
        mapContentTextDom.addEventListener('mouseenter', function () {
          _this.mainStore.pageSwiper.isScrollEnabled = false;
        });

        // 鼠标移出事件
        mapContentTextDom.addEventListener('mouseleave', function () {
          _this.mainStore.pageSwiper.isScrollEnabled = true;
        });
      }
    });
  }
}

export default FourSectionStore;
